export const iconFontAwesomeChildhoodIceCream = (
	<i className="fa-solid fa-ice-cream"></i>
);
